module.exports = __webpack_public_path__ + "img/useful_hero_lg.40bc8b14.png";